import { z } from "zod/v4";
import { dvvPickerAthleteSchema, dvvSyncReportSchema, playerSchema } from "../../schemas/bis";
import { fetchApi } from "../client/internal";

export const roster = {
	list: (params?: { q?: string; sort?: string }) => {
		const query = new URLSearchParams();
		if (params?.q) query.set("q", params.q);
		if (params?.sort) query.set("sort", params.sort);
		const qs = query.toString();
		return fetchApi(`/players${qs ? `?${qs}` : ""}`, z.array(playerSchema));
	},
	get: (id: string) => fetchApi(`/players/${id}`, playerSchema),
	create: (body: any) =>
		fetchApi(`/players`, playerSchema, {
			method: "POST",
			body: JSON.stringify(body),
		}),
	update: (id: string, body: any) =>
		fetchApi(`/players/${id}`, playerSchema, {
			method: "PUT",
			body: JSON.stringify(body),
		}),
	remove: (id: string) =>
		fetchApi(`/players/${id}`, z.object({ deleted: z.boolean() }), {
			method: "DELETE",
		}),

	// DVV link — set or clear the soft FK to a scraped athlete.
	setDvvLink: (id: string, dvvId: string | null) =>
		fetchApi(`/players/${id}/dvv-link`, playerSchema, {
			method: "PUT",
			body: JSON.stringify({ dvvId }),
		}),
	clearDvvLink: (id: string) =>
		fetchApi(`/players/${id}/dvv-link`, playerSchema, {
			method: "DELETE",
		}),

	// DVV sync — pull license + ranking points from the linked scraped athlete.
	syncDvv: (id: string) =>
		fetchApi(`/players/${id}/sync-dvv`, playerSchema, {
			method: "POST",
		}),
	syncDvvAll: () =>
		fetchApi(`/players/sync-dvv`, dvvSyncReportSchema, {
			method: "POST",
		}),

	// DVV picker — search the discovery `scraped_athletes` table for the link dialog.
	searchScrapedAthletes: (params?: { q?: string; limit?: number }) => {
		const query = new URLSearchParams();
		if (params?.q) query.set("q", params.q);
		if (params?.limit) query.set("limit", String(params.limit));
		const qs = query.toString();
		return fetchApi(`/scraped-athletes${qs ? `?${qs}` : ""}`, z.array(dvvPickerAthleteSchema));
	},
};
